(() => {
  if (window.drboHerbstFeaturePurchase) return;
  window.drboHerbstFeaturePurchase = true;
  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-feature-form]');
    if (!form) return;
    event.preventDefault();
    if (form.dataset.pending === 'true') return;
    const region = form.closest('[data-herbst-feature]');
    const status = region.querySelector('[data-feature-status]');
    const cartLink = region.querySelector('[data-feature-cart-link]');
    const buttons = Array.from(form.querySelectorAll('button'));
    const checkout = event.submitter?.dataset.intent === 'checkout';
    const quantity = Number(form.elements.quantity.value);
    const variantId = Number(form.elements.id.value);
    const cartUrl = window.Shopify?.routes?.root ? `${window.Shopify.routes.root}cart` : form.dataset.cartUrl;
    const isEnglish = /^en(?:-|$)/i.test(document.documentElement.lang);
    let added = false;
    form.dataset.pending = 'true';
    form.setAttribute('aria-busy', 'true');
    buttons.forEach(button => { button.disabled = true; });
    status.hidden = false;
    status.removeAttribute('data-error');
    status.textContent = checkout ? (isEnglish ? 'Your item is being prepared for checkout ...' : 'Dein Artikel wird für die Kasse vorbereitet …') : (isEnglish ? 'Adding to cart ...' : 'Wird zum Warenkorb hinzugefügt …');
    cartLink.hidden = true;
    try {
      const response = await fetch(`${form.action}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity }] })
      });
      const result = await response.json();
      if (!response.ok) {
        const failure = new Error('Cart request rejected');
        failure.customerMessage = result.description || (isEnglish ? 'The item could not be added. Please try again.' : 'Der Artikel konnte nicht hinzugefügt werden. Bitte versuche es erneut.');
        throw failure;
      }
      added = true;
      status.textContent = (isEnglish ? 'SunEnergyXT 500 PRO has been added to your cart.' : 'SunEnergyXT 500 PRO wurde zum Warenkorb hinzugefügt.');
      cartLink.hidden = false;
      if (checkout) {
        const checkoutForm = document.createElement('form');
        checkoutForm.method = 'post';
        checkoutForm.action = cartUrl;
        const checkoutInput = document.createElement('input');
        checkoutInput.type = 'hidden';
        checkoutInput.name = 'checkout';
        checkoutInput.value = '1';
        checkoutForm.append(checkoutInput);
        document.body.append(checkoutForm);
        checkoutForm.submit();
        return;
      }
      try {
        const cartResponse = await fetch(`${cartUrl}.js`, { headers: { Accept: 'application/json' } });
        if (cartResponse.ok) {
          const cart = await cartResponse.json();
          if (window.themeCore) window.themeCore.cartObject = cart;
          window.themeCore?.EventBus?.emit('header:update-item-count', { item_count: cart.item_count });
        }
        window.themeCore?.EventBus?.emit('cart:refresh');
      } catch (_) {
        status.textContent = (isEnglish ? 'The item is in your cart. Open your cart to view it.' : 'Der Artikel ist im Warenkorb. Öffne den Warenkorb, um ihn anzusehen.');
      }
    } catch (error) {
      status.setAttribute('data-error', '');
      status.textContent = added ? (isEnglish ? 'The item is in your cart. Please open your cart to proceed to checkout.' : 'Der Artikel ist im Warenkorb. Bitte öffne den Warenkorb, um zur Kasse zu gehen.') : error.customerMessage || (isEnglish ? 'We could not confirm whether the item was added. Please check your cart before trying again.' : 'Das Hinzufügen konnte nicht bestätigt werden. Prüfe bitte den Warenkorb, bevor Du es erneut versuchst.');
      cartLink.hidden = false;
    } finally {
      if (!(checkout && added)) {
        delete form.dataset.pending;
        form.removeAttribute('aria-busy');
        buttons.forEach(button => { button.disabled = false; });
      }
    }
  });
  window.addEventListener('pageshow', () => {
    document.querySelectorAll('[data-feature-form]').forEach(form => {
      delete form.dataset.pending;
      form.removeAttribute('aria-busy');
      form.querySelectorAll('button').forEach(button => { button.disabled = false; });
    });
  });
})();
